const removeUndefinedFields = <T extends Record<string, unknown>>(data: T): Partial<T> =>
  Object.fromEntries(Object.entries(data).filter(([_, value]) => value !== undefined)) as Partial<T>;

export { removeUndefinedFields };
